import { memo, useMemo } from 'react'
import { useFormState } from 'react-final-form'
import cn from 'classnames'
import IconAlert from 'remixicon/icons/System/alert-fill.svg?react'
import { OrderCargoInfo } from 'schema'
import { formatNumber } from 'shared/helpers/formatNumber'

import { prepareCargo } from '../../helpers/order'
import { IOrderCreateFormData } from '../../types/orderGuestCreateTypes'
import { LENGTH_LIMIT, LENGTH_LIMIT_IN_CENTIMETER } from './constants'

interface IProps {
  className?: string
}

export const OrderCargoLengthLimitWarning = memo<IProps>(function OrderCargoLengthLimitWarning({ className }) {
  const { values } = useFormState<IOrderCreateFormData>()
  const { cargoType, cargoTotal, cargo, departurePoint, destinationPoint, customer } = values
  const hasSpecialCargoLimits = customer?.hasSpecialCargoLimits

  const isShowWarning = useMemo(() => {
    const isCourier = departurePoint?.isCourier || destinationPoint?.isCourier

    if (!cargoType) {
      return false
    }

    if (cargoType === OrderCargoInfo.type.SEPARATE && cargo && isCourier && hasSpecialCargoLimits) {
      return prepareCargo(cargo).some(({ length }) => length > LENGTH_LIMIT_IN_CENTIMETER)
    }

    if (cargoType === OrderCargoInfo.type.TOTAL && cargoTotal && isCourier) {
      return cargoTotal.length > LENGTH_LIMIT
    }

    return false
  }, [cargo, cargoTotal, cargoType, departurePoint?.isCourier, destinationPoint?.isCourier, hasSpecialCargoLimits])

  return isShowWarning ? (
    <div
      className={cn(className, 'mt-2 grid grid-cols-[auto_1fr] items-start gap-x-4 rounded bg-attention-container p-3')}
    >
      <IconAlert className="text-on-attention-container" containerSize="nm" size="xs" />
      <div>
        Возможно увеличение стоимости заявки в&nbsp;части дополнительных услуг или исключение из&nbsp;него услуги
        доставки/забора курьером, так как ваш груз негабаритный&nbsp;&mdash; длина более{' '}
        {formatNumber({ value: LENGTH_LIMIT, precision: 1 })}&nbsp;метров. Наш оператор свяжется с&nbsp;вами, если такая
        корректировка заявки потребуется.
      </div>
    </div>
  ) : null
})
